import OtherOffersLink from './other-offers-link';

export default OtherOffersLink;